<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<div class="ext_ch">
<div class="decoration-rw10">
<div class="media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw">
<div class="pc-rw"><img alt="" class="orn1" src="images/Art_Pv.jpg"/></div>
</div>
</div>
</div>
<p class="dedication"><em>For my sister, Briony.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2cfe1fa6